<app-sub-title [titleText]="'ORGANIZATION' | translate"></app-sub-title>
<div class="organization">
    <div class="flex header-wrap">
        <div class="name-rect"*ngIf="userData?.queryUserPageInfoResDTO?.name">
            {{ userData?.queryUserPageInfoResDTO?.name?.substring(0, 2) }}</div>
        <div class="info-wrap">
            <div class="font18-w700 mb8">{{ userData?.queryUserPageInfoResDTO?.customerName ?? "--" }}</div>
            <div class="font16-w500">{{ userData?.queryUserPageInfoResDTO?.customerCode ?? "--" }}</div>
        </div>
    </div>
    <div class="tabs flex-between">
        <ul class="flex">
          <li [class]="{'active':activeTab=='section1'?true:false}" (click)="scrollToAnchor('section1')">{{'ADDRESS_LIST' | translate}}</li>
          <li [class]="{'active':activeTab=='section2'?true:false}" (click)="scrollToAnchor('section2')">{{'LEGAL' | translate}}</li>
        </ul>
    </div>
      
      <div id="section1" class="content">
        <div class="flex-v-center mb20 mt30">
            <svg-icon  [iconName]="'my-info.svg'" class="mr10" [size]="48"></svg-icon>
            <span class="font16-w700 color-grey">{{'ADDRESS_LIST'| translate}}</span>
        </div>
        <div>
            <nz-input-group [nzSuffix]="suffixIconSearch" class="search_input" >
            <input type="text" nz-input [placeholder]="'SEARCH'| translate"   [(ngModel)]="address" (keyup.enter)="handleSearchByAddress()" />
            </nz-input-group>
            <ng-template #suffixIconSearch>
            <i nz-icon nzType="search" class="cursor-pointer" (click)="handleSearchByAddress()"></i>
            </ng-template>
            <div class="address-wrap">
            <div class="address-list flex">
                <div class="address-item" *ngFor="let address of searchResults; let i = index;">
                <div class="address flex">
                    <div class="address-info">
                        <div class="title mb12">{{address.customerCode}}</div>
                        <div class="title mb12">{{address.addressName}}</div>
                        <div class="desc-address mb12">{{address.streetName}}</div>
                        <div class="desc-address mb12">{{address.postcode}} {{address.city}}</div>
                        <div class="desc-address mb12">{{address.country}} {{address.state}}</div>
                        <div class="desc-address">{{address.phone}}</div>
                    </div>
                </div>
                <div class="default flex"><span>{{"SET_DEFAULT" | translate}}</span>
                    <div>
                        <svg-icon class="cursor-pointer" [size]="20" [iconName]="'un-choose.svg'" [class.hidden]="address?.userDefault" (click)="chooseAddress(address)"></svg-icon>
                        <svg-icon class="cursor-pointer" [size]="20" [iconName]="'choosed.svg'" [class.hidden]="!address?.userDefault"   (click)="chooseAddress(address)"></svg-icon>
                      </div>
                </div>
            </div>
        </div>
            </div>
        </div>
      </div>
      
      <div id="section2" class="content">
        <div class="flex-v-center mt30">
            <svg-icon  [iconName]="'my-info.svg'" class="mr10" [size]="48"></svg-icon>
            <span class="font16-w700 color-grey">{{'LEGAL'| translate}}</span>
        </div>
        <div class="desc">
            <p>{{'LEGAL_TITLE' | translate}}</p>
            <p>{{'LEGAL_CONTENT' | translate}}</p>
        </div>
      </div>
</div>
